import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import Table from "../../../../Components/Table";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import {
    InserirEnvelopeController,
    ListarConfigEnvelopeController,
} from "../../../../Controllers/Geral/Envelopes/EnvelopesControllers";
import useArrayState from "../../../../hooks/useArrayState";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import {
    IDocumentosAdicionais,
    IEnvelopeDocusignConfig,
} from "../../../../Interfaces/Geral/Envelopes/EnvelopesInterface";

interface IConfigurarEnvelopeEnvioProps {
    idEnvelopeDocusignConfig: number;
    documentosAdicionais: Array<IDocumentosAdicionais>;
}

export default function ConfigurarEnvelopeEnvio(
    props: IConfigurarEnvelopeEnvioProps
) {
    const { value: configEnvelopesLst, loading: configEnvelopesLstLoading } =
        useAsyncEffect(() =>
            ListarConfigEnvelopeController(props.idEnvelopeDocusignConfig)
        );

    const { ID_CASO } = useAtendimentoPage();

    const { execute: executeInserirEnvelope, loading: inserirEnvelopeLoading } =
        useAsyncCallback(InserirEnvelopeController);

    const [lstEnvelopesLst, setLstEnvelopesLst] = useArrayState<IEnvelopeDocusignConfig>();
    const [fetchedDocumentosAdicionais, setFetchedDocumentosAdicionais] = useArrayState<IDocumentosAdicionais>();
    const [documentoExcluidos, setDocumentosExcluidos] = useArrayState<IEnvelopeDocusignConfig>();

    useEffect(() => {
        if (configEnvelopesLst) {
            //@ts-ignore
            setLstEnvelopesLst.add(configEnvelopesLst);
            //@ts-ignore
            setFetchedDocumentosAdicionais.add(props.documentosAdicionais);
        }
    }, [
        configEnvelopesLst,
        props.documentosAdicionais,
        setLstEnvelopesLst,
        setFetchedDocumentosAdicionais,
    ]);


    const tableviewColumns: Array<ColumnDescription<IEnvelopeDocusignConfig>> =
        [
            {
                dataField: "NR_ORDEM",
                text: "Ordem",
                formatter: (_, __, index) => 
                <span>{index}</span>
            },
            {
                dataField: "DS_DOCUMENTO",
                text: "Arquivo",
                formatter: (_, row) =>
                    row.DS_DOCUMENTO ? (
                        <span>{row.DS_DOCUMENTO}</span>
                    ) : (
                        row.DS_DOCUMENTO_PRODUTO
                    ),
            },
            {
                dataField: "Ver Caso",
                text: "",
                isDummyField: true,
                formatter: (_, row) =>
                    row.FL_DOCUMENTO_FILHO ? (
                        <div
                            key={row.ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO}
                            className="Button-Tools"
                        >
                            <button
                                className="btn btn-outline-danger font-weight-bold mr-2 "
                                onClick={() => {
                                    setDocumentosExcluidos.add(row);
                                    setLstEnvelopesLst.remove(row);
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                                <span className="d-none d-sm-block">
                                    Excluir
                                </span>
                            </button>
                        </div>
                    ) : (
                        ""
                    ),
            },
        ];


    const tableviewDocumentosAdicionaisColumns: Array<
        ColumnDescription<IDocumentosAdicionais>
    > = [
        {
            dataField: "DS_NOME_ARQUIVO",
            text: "Arquivo",
            formatter: (_, row) => 
                row.DS_NOME_ARQUIVO ? (
                    <span>{row.DS_NOME_ARQUIVO}</span>
                ) : (
                    row.DS_DOCUMENTO ? (
                        <span>{row.DS_DOCUMENTO}</span>
                    ) : (
                        <span>{row.DS_DOCUMENTO_PRODUTO}</span>
                    )
                )
        },
        {
            dataField: "Ver Caso",
            text: "",
            isDummyField: true,
            formatter: (_, row, index) =>
                row.FL_DOCUMENTO_FILHO ? (
                    <div
                        key={row.ID_DOCUMENTO_PRODUTO}
                        className="Button-Tools"
                    >
                        <button
                            className="btn btn-outline-danger font-weight-bold mr-2 "
                            onClick={() => {
                                setFetchedDocumentosAdicionais.remove(row);
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} size="lg" />{" "}
                            <span className="d-none d-sm-block">Excluir</span>
                        </button>
                    </div>
                ) : (
                    ""
                ),
        },
    ];

    const tableViewDocumentosExcluidos: Array<
        ColumnDescription<IEnvelopeDocusignConfig>
    > = [
        {
            dataField: "DS_DOCUMENTO",
            text: "Arquivo",
            formatter: (_, row) =>
                    row.DS_DOCUMENTO ? (
                        <span>{row.DS_DOCUMENTO}</span>
                    ) : (
                        row.DS_DOCUMENTO_PRODUTO
                    ),
        },
        {
            dataField: "Ver Caso",
            text: "",
            isDummyField: true,
            formatter: (_, row) =>
                row.FL_DOCUMENTO_FILHO ? (
                    <div
                        key={row.ID_DOCUMENTO_PRODUTO}
                        className="Button-Tools"
                    >
                        <button
                            className="btn btn-outline-primary font-weight-bold mr-2 "
                            onClick={() => {
                                setLstEnvelopesLst.add(row);
                                setDocumentosExcluidos.remove(row);
                            }}
                        >
                            <FontAwesomeIcon icon={faPlus} size="lg" />{" "}
                            <span className="d-none d-sm-block">Adicionar</span>
                        </button>
                    </div>
                ) : (
                    ""
                ),
        },
    ];

    return (
        <>
            <div className="d-flex">
                <div className="col-6">
                    <h1>Documentos</h1>
                    {lstEnvelopesLst && (
                        <Table
                            wrapperClasses="mw-100 custom-scroll"
                            columns={tableviewColumns}
                            data={lstEnvelopesLst}
                            keyField="ID_ENVELOPE_DOCUSIGN_CONFIG_DOCUMENTO"
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Documento Encontrado
                                </div>
                            )}
                            noHover
                            noSearch
                            loading={configEnvelopesLstLoading}
                            rowStyle={{ height: 50 }}
                            bordered={false}
                            defaultStyle={{ align: "center" }}
                            striped={true}
                            rowClasses={"rowClasses"}
                            center={true}
                            sizePerPage={100}
                            noPagination={true}
                        />
                    )}
                </div>

                <div className="col-6">
                    <h1>Documentos Adicionais </h1>
                    {fetchedDocumentosAdicionais && (
                        <Table
                            wrapperClasses="mw-100 custom-scroll"
                            columns={tableviewDocumentosAdicionaisColumns}
                            data={fetchedDocumentosAdicionais}
                            keyField="ID_DOCUMENTO_PRODUTO"
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Documento Adicional Encontrado
                                </div>
                            )}
                            noHover
                            noSearch
                            loading={configEnvelopesLstLoading ?? []}
                            rowStyle={{ height: 50 }}
                            bordered={false}
                            defaultStyle={{ align: "center" }}
                            striped={true}
                            rowClasses={"rowClasses"}
                            center={true}
                            noPagination={true}
                            sizePerPage={100}
                        />
                    )}
                </div>
            </div>

            <div className="d-flex col-12">
                <div className="col-6">
                    <h1 className="mt-5">Documentos Excluidos </h1>
                    {documentoExcluidos && (
                        <Table
                            wrapperClasses="mw-100 custom-scroll"
                            columns={tableViewDocumentosExcluidos}
                            data={documentoExcluidos}
                            keyField="ID_DOCUMENTO_PRODUTO"
                            noDataIndication={() => (
                                <div className="text-black-50 text-center">
                                    Nenhum Documento Adicional Encontrado
                                </div>
                            )}
                            noHover
                            noSearch
                            loading={configEnvelopesLstLoading ?? []}
                            rowStyle={{ height: 50 }}
                            bordered={false}
                            defaultStyle={{ align: "center" }}
                            striped={true}
                            rowClasses={"rowClasses"}
                            center={true}
                            noPagination={true}
                            sizePerPage={100}
                        />
                    )}
                </div>
            </div>

            <div className="d-flex w-100 justify-content-end">
                <button
                    className="btn btn-primary"
                    type="submit"
                    disabled={!lstEnvelopesLst}
                    onClick={() => {
                        if(lstEnvelopesLst) {
                            executeInserirEnvelope({ ID_CASO, LST_DOCUMENTOS_EXCLUIDOS: documentoExcluidos, LST_DOCUMENTOS_ADICIONAIS: fetchedDocumentosAdicionais, ID_ENVELOPE_DOCUSIGN_CONFIG: props.idEnvelopeDocusignConfig })
                        }
                    }}
                >
                    {inserirEnvelopeLoading ? <span className="d-flex align-items-center"> <Spinner size="sm" /> Enviar Envelope</span> : <span>Enviar Envelope</span>}
                </button>
            </div>
        </>
    );
}
